import { Injectable } from '@angular/core';
import { G_PackagesTypeViewModel } from 'src/app/viewmodels/g-packages/G_PackagesTypeViewModel';
import { EndpointConfig } from '../../common/EndpointConfig';
import { IHttpService } from '../../common/IHttpService';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PackageTypeService implements IHttpService<G_PackagesTypeViewModel> {
  private _ep: EndpointConfig;
  constructor(private _client: HttpClient) {
    this._ep = new EndpointConfig('GSSItem');
  }

  GetList() {
    return this._client.get(this._ep.getEndpointMethod('GetG_PackageTypeList'));
  }

  GetById(id: any) {
    return this._client.post(this._ep.getEndpointMethod('GetG_PackageTypeById'), { Id: id });
  }
  Post(obj: G_PackagesTypeViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_PackageType'), obj);
  }

  checkDublication(code) {
    return this._client.post(this._ep.getEndpointMethod('CheckPackageTypeDuplication'), { Code: code });
  }

  Put(obj: G_PackagesTypeViewModel) {
    return this._client.post(this._ep.getEndpointMethod('SaveG_PackageType'), obj);
  }

  Delete(obj: G_PackagesTypeViewModel) {
    return this._client.post(this._ep.getEndpointMethod('DeleteG_PackageType'), obj);
  }
}
